import AmexExpandableSection from './AmexExpandableSection';

export default AmexExpandableSection;
